import { render, staticRenderFns } from "./CustomFieldComplexExample.vue?vue&type=template&id=00697647&scoped=true&"
import script from "./CustomFieldComplexExample.vue?vue&type=script&lang=ts&"
export * from "./CustomFieldComplexExample.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00697647",
  null
  
)

export default component.exports